
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class ModellingViewColumnSetGrid extends SiteEntityGrid<ModellingViewColumnSetRow, any> {
        protected getColumnsKey() { return 'Rebalancer.ModellingViewColumnSet'; }
        protected getDialogType() { return ModellingViewColumnSetDialog; }
        protected getIdProperty() { return ModellingViewColumnSetRow.idProperty; }
        protected getLocalTextPrefix() { return ModellingViewColumnSetRow.localTextPrefix; }
        protected getService() { return ModellingViewColumnSetService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}